export function mapApiAddressToContactAddress(a) {
    return {
        id: a.id,
        type: a.type,
        label: a.label,
        line1: a.addressLine,
        line2: a.addressLine2,
        line3: a.addressLine3,
        houseNumber: a.houseNumber,
        houseNumberSuffix: a.houseNumberSuffix,
        postalCode: a.postalCode,
        city: a.city,
        region: a.region,
        country: a.country,
        isPrimary: a.isPrimary,
        source: a.source,
        linkId: a.linkId,
        organisationId: a.organisationId,
        organisationName: a.organisationName,
        isReadOnly: a.isReadOnly,
    };
}
